module.exports = __webpack_public_path__ + "static/media/banff-40.1e6b4d98.jpg";